import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-image-zoom',
    templateUrl: './image-zoom.component.html',
    styleUrls: ['./image-zoom.component.css'],
    standalone: false
})
export class ImageZoomComponent {
  @Input() src: any;
  showZoom: boolean;

  public topPosition: string;
  public leftPosition: string;

  constructor() {
    this.showZoom = false;
  }

  setZoom(event: any, show: boolean) {
    this.showZoom = show;
  }

  positionZoom(event) {
  }
}


